import * as React from 'react'

export interface IUnsplashImageProps {
	// settings
	q: number
	fit: string
	crop: string
	ixlib: string
	width: number
	height: number

	// default image
	title: string
	link: string
	fileName: string
	ixid: string
	userName: string
}

// see https://docs.imgix.com/apis/rendering
const defaultProps = {
	// default settings
	q: 80,
	fit: 'max',
	crop: 'entropy',
	ixlib: 'rb-4.0.3',

	// default image
	link: 'https://unsplash.com/photos/bJhT_8nbUA0?utm_source=masterchallenge&utm_medium=referral',
	fileName: 'photo-1502101872923-d48509bff386',
	ixid: 'M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA',
	userName: 'Jukan Tateisi',
}

export default function UnsplashImage(props: IUnsplashImageProps) {
	props = { ...defaultProps, ...props }
	return (
		<>
			<img
				className="absolute w-full h-full object-cover"
				src={`https://images.unsplash.com/${props.fileName}?ixid=${props.ixid}&ixlib==${props.ixlib}&w=${props.width}&h=${props.height}&q=${props.q}&fit=${props.fit}&crop=${props.crop}`}
				alt={props.title}
			/>
			<span
				className="text-white absolute z-20 right-2 bottom-2"
				style={{ fontSize: '0.5rem' }}
			>
				Photo by{' '}
				<a
					onClick={(e) => {
						e.preventDefault()
						window.open(`${props.link}`)
					}}
					href={props.link}
					className="font-semibold text-white"
				>
					{props.userName}
				</a>
			</span>
		</>
	)
}
